/* eslint-disable */
export default {
  noResultFoundFor: 'Nenhum resultado encontrado para',
  foundFromServerHint:
    'Digite a palavra-chave e pressione Enter para pesquisar em {appName}',
  notResultFoundFromServer: 'Nenhum resultado encontrado',
  loading: 'carregando...',
} as const;

// @key: @#@"noResultFoundFor"@#@ @source: @#@"No result found for"@#@
// @key: @#@"foundFromServerHint"@#@ @source: @#@"Type keyword and press Enter to search in {appName}"@#@
// @key: @#@"notResultFoundFromServer"@#@ @source: @#@"No results found"@#@
// @key: @#@"loading"@#@ @source: @#@"loading..."@#@
